// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","breadcrumb":"breadcrumb-2B2PC","close":"close-12Hlx"};